import { Navigate, useNavigate } from "react-router-dom";
import { Hourglass, RefreshCw, LogOut, Ban } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Loader, Logo } from "../components/common";
import { ContactOnboarding, needsContact } from "../components/ContactOnboarding";

export default function Pending() {
  const { user, loading, refresh, logout } = useAuth();
  const navigate = useNavigate();
  if (loading) return <Loader full />;
  if (!user) return <Navigate to="/" replace />;
  if (user.status === "approved") return <Navigate to="/app" replace />;
  if (user.status === "pending" && needsContact(user)) return <ContactOnboarding />;
  const rejected = user.status === "rejected";
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0E14] px-5">
      <div className="card-x w-full max-w-md p-8 text-center rise">
        <div className="mb-8 flex justify-center"><Logo /></div>
        {rejected ? <Ban className="mx-auto h-12 w-12 text-red-400" /> : <Hourglass className="mx-auto h-12 w-12 text-[#E4F222]" strokeWidth={1.5} />}
        <h1 data-testid="pending-title" className="h-display mt-4 text-4xl">{rejected ? "Acesso negado" : "Aguardando aprovação"}</h1>
        <p className="mt-2 text-sm text-[#94A3B8]">
          {rejected ? "Seu acesso não foi aprovado pela organização." : `Olá, ${user.name}! Seu cadastro (${user.email}) foi recebido. A organização do circuito irá aprovar seu acesso em breve.`}
        </p>
        <div className="mt-8 flex flex-col gap-3">
          <button data-testid="pending-refresh-btn" onClick={refresh} className="btn-lime flex items-center justify-center gap-2 rounded-full py-3">
            <RefreshCw className="h-4 w-4" /> Verificar novamente
          </button>
          <button data-testid="pending-logout-btn" onClick={async () => { await logout(); navigate("/"); }} className="flex items-center justify-center gap-2 py-2 text-sm text-[#94A3B8] hover:text-white">
            <LogOut className="h-4 w-4" /> Sair
          </button>
        </div>
      </div>
    </div>
  );
}
